<app-shimmer *ngIf="key" [key]="key"></app-shimmer>
<router-outlet></router-outlet>